import { components } from 'react-select'

export const SelectControlWithTestId = (props) => {
  const { selectProps, ...rest } = props
  const testId = selectProps?.testId || selectProps?.['data-testid']
  return (
    <components.Control
      {...rest}
      innerProps={{
        ...rest.innerProps,
        ...(testId ? { 'data-testid': testId } : {}),
      }}
    />
  )
}

const SelectInputWithTestId = (props) => {
  const { selectProps } = props
  const testId = selectProps?.testId || selectProps?.['data-testid']
  return (
    <components.Input
      {...props}
      data-testid={testId ? `${testId}-input` : undefined}
    />
  )
}

export default SelectInputWithTestId
